module.exports = __webpack_public_path__ + "static/img/fz_dlb_tb.797777d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_dlb_tb.png
// module id = wYkr
// module chunks = 0